const state = {
  reviewOptionTypes: [],
  isLoadingReviewOptionTypes: true,
  isReviewOptionTypeFilterShowable: true
};

const mutations = {
  SET_REVIEW_OPTION_TYPES(state, reviewOptionTypes) {
    state.reviewOptionTypes = reviewOptionTypes;
  },
  SET_IS_LOADING_REVIEW_OPTION_TYPES(state, isLoadingReviewOptionTypes) {
    state.isLoadingReviewOptionTypes = isLoadingReviewOptionTypes;
  },
  SET_IS_REVIEW_OPTION_TYPE_FILTER_SHOWABLE(
    state,
    isReviewOptionTypeFilterShowable
  ) {
    state.isReviewOptionTypeFilterShowable = isReviewOptionTypeFilterShowable;
  }
};

const actions = {
  fetchReviewOptionTypes({ commit, rootState }) {
    const product_code = rootState.productCode;
    commit('SET_IS_LOADING_REVIEW_OPTION_TYPES', true);
    rootState.api
      .fetchReviewOptionTypes(product_code)
      .then(({ data }) => {
        commit('SET_REVIEW_OPTION_TYPES', data.review_option_types);
        commit(
          'SET_IS_REVIEW_OPTION_TYPE_FILTER_SHOWABLE',
          data.review_option_types.length > 0
        );
      })
      .finally(() => commit('SET_IS_LOADING_REVIEW_OPTION_TYPES', false));
  }
};

export default { namespaced: true, state, mutations, actions };
